export function getMetaContent(name) {
  return document.head.querySelector(`meta[name=${name}]`)?.getAttribute("content")
}
